import {render} from 'react-dom';

import Routes from "./Routes";

render( Routes, document.getElementById( 'movies' ) );



// WEBPACK FOOTER //
// ./js/movies/index.jsx